import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Store } from '@/store/Store'

export interface RouterContext {
  currentUser: Store['auth']['currentUser']
}

const RootLayout = () => (
  <>
    <Outlet />
    <TanStackRouterDevtools />
  </>
)

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout
})